module.exports = __webpack_public_path__ + "img/doctor-id.c9c89d97.svg";